import { Suspense } from 'react';
import { createPortal } from 'react-dom';
import { useDrawer } from '../DrawerContext';
import { Loader } from '../Loader';
import { AnyComponent } from '@nexelem/utils';

type DrawerPortalProps = {
  anchor: 'left' | 'right';
  Component: AnyComponent;
  props?: unknown;
};

export const DrawerPortal = ({ props, Component, anchor }: DrawerPortalProps) => {
  const drawer = useDrawer();
  const ref = 'left' === anchor ? drawer?.leftRef : drawer?.rightRef;

  if (!ref) {
    return null;
  }

  return createPortal(
    <Suspense fallback={<Loader />}>
      <Component {...(props || {})} />
    </Suspense>,
    ref,
  );
};

DrawerPortal.displayName = 'DrawerPortal';
